import React from 'react';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import PropTypes from 'prop-types';

import BillingTestKeys from '../../../Utils/BillingTestKeys.js';
import VfView from '../../VfView';

import styles from './ExpansionPanelTotal.Styles';

function ExpansionPanelTotal(props) {
  const { theme } = props;
  return (
    <VfView style={props.style}>
      <VfView justify="space-between" row style={styles.root}>
        <VFText
          i18nKey={`${props.noVatLabel}`}
          style={[styles.totalBeforeVatText(theme), props.totalBeforeVatTextStyle]}
          testKey={BillingTestKeys.expansionPanelTotalBeforeVatLabelText}
        />
        <VFText
          i18nKey={`${props.noVatValue}`}
          style={[styles.totalBeforeVatText(theme), props.totalBeforeVatTextStyle]}
          testKey={BillingTestKeys.expansionPanelTotalBeforeVatValueText}
        />
      </VfView>
      <VfView justify="space-between" row>
        <VFText
          i18nKey={`${props.vatLabel}`}
          style={[styles.vatText(theme), props.vatTextStyle]}
          testKey={BillingTestKeys.expansionPanelVatLabelText}
        />
        <VFText
          i18nKey={`${props.vatValue}`}
          style={[styles.vatText(theme), props.vatTextStyle]}
          testKey={BillingTestKeys.expansionPanelVatValueText}
        />
      </VfView>
      <VfView row justify="space-between" style={styles.totalContainer}>
        <VFText
          i18nKey={`${props.totalLabel}`}
          style={[styles.totalPayText(theme), props.totalLabelStyle]}
          testKey={BillingTestKeys.expansionPanelTotalWithVatLabelText}
        />
        <VFText
          i18nKey={`${props.totalValue}`}
          style={[styles.totalPayText(theme), props.totalValueStyle]}
          testKey={BillingTestKeys.expansionPanelTotalWithVatValueText}
        />
      </VfView>
    </VfView>
  );
}

ExpansionPanelTotal.defaultProps = {
  theme: LightThemeColors,
  showTotalBeforeCollapsedItems: false,
};

ExpansionPanelTotal.propTypes = {
  style: PropTypes.object,
  totalLabelStyle: PropTypes.object,
  totalValueStyle: PropTypes.object,
  vatTextStyle: PropTypes.object,
  totalBeforeVatTextStyle: PropTypes.object,
  noVatLabel: PropTypes.string,
  noVatValue: PropTypes.string,
  vatLabel: PropTypes.string,
  vatValue: PropTypes.string,
  totalLabel: PropTypes.string,
  totalValue: PropTypes.string,
  theme: PropTypes.object,
  showTotalBeforeCollapsedItems: PropTypes.bool,
};

export default withTheme(ExpansionPanelTotal);
